/* Exact Flings Crunchies homepage — progressive enhancement, no dependencies. */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function burstPath(pts, outerR, innerR) {
    var cx = 50, cy = 50, d = '';
    for (var i = 0; i < pts * 2; i++) {
      var a = (Math.PI * i) / pts - Math.PI / 2;
      var r = i % 2 === 0 ? outerR : innerR;
      d += (i === 0 ? 'M' : 'L') + (cx + Math.cos(a) * r).toFixed(2) + ',' + (cy + Math.sin(a) * r).toFixed(2) + ' ';
    }
    return d + 'Z';
  }

  function buildBursts(root) {
    (root || document).querySelectorAll('[data-burst]').forEach(function (el) {
      if (el.dataset.burstReady) return;
      var p = (el.getAttribute('data-burst') || '16,50,38').split(',').map(Number);
      el.innerHTML = '<svg viewBox="0 0 100 100" aria-hidden="true"><path d="' + burstPath(p[0], p[1], p[2]) + '" fill="currentColor"/></svg>';
      el.dataset.burstReady = '1';
    });
  }

  var STAR = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2l2.9 6.5 7.1.7-5.4 4.9 1.6 7-6.2-3.6L5.8 21l1.6-7L2 9.2l7.1-.7z"/></svg>';
  function buildStars(root) {
    (root || document).querySelectorAll('[data-star]').forEach(function (el) {
      if (!el.dataset.starReady) { el.innerHTML = STAR; el.dataset.starReady = '1'; }
    });
  }

  function initReveal(root) {
    var reveals = (root || document).querySelectorAll('[data-reveal]');
    if (!reduceMotion && 'IntersectionObserver' in window) {
      reveals.forEach(function (el) { if (!el.classList.contains('in')) el.classList.add('pre'); });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.remove('pre'); e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px' });
      reveals.forEach(function (el) { io.observe(el); });
    }
  }

  function initCarousel(root) {
    (root || document).querySelectorAll('[data-carousel]').forEach(function (carousel) {
      if (carousel.dataset.carouselReady) return;
      var dotsId = carousel.getAttribute('data-dots');
      var dotsWrap = dotsId ? document.getElementById(dotsId) : null;
      var dots = dotsWrap ? dotsWrap.querySelectorAll('span') : [];
      carousel.addEventListener('scroll', function () {
        var slide = carousel.querySelector('.fling-arch');
        if (!slide || !dots.length) return;
        var w = slide.offsetWidth + 14;
        var i = Math.max(0, Math.min(dots.length - 1, Math.round(carousel.scrollLeft / w)));
        dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
      }, { passive: true });
      carousel.dataset.carouselReady = '1';
    });
  }

  function initMobileSecondarySwipe(root) {
    (root || document).querySelectorAll('.c-shop .fling-arch').forEach(function (card) {
      if (card.dataset.secondarySwipeReady) return;
      var art = card.querySelector('.art');
      var secondary = card.querySelector('.hover-client-art .hover-art');
      if (!art || !secondary) return;

      var startX = 0, startY = 0;
      art.addEventListener('touchstart', function (event) {
        if (!event.touches || event.touches.length !== 1) return;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
      }, { passive: true });

      art.addEventListener('touchend', function (event) {
        if (!event.changedTouches || event.changedTouches.length !== 1) return;
        var dx = event.changedTouches[0].clientX - startX;
        var dy = event.changedTouches[0].clientY - startY;
        if (Math.abs(dx) < 32 || Math.abs(dx) <= Math.abs(dy)) return;
        if (dx < 0) card.classList.add('is-secondary-art');
        else card.classList.remove('is-secondary-art');
      }, { passive: true });

      card.dataset.secondarySwipeReady = '1';
    });
  }

  function buildQR(root) {
    (root || document).querySelectorAll('[data-qr]').forEach(function (qrBox) {
      if (qrBox.dataset.qrReady || qrBox.children.length) return;
      var size = 21, seed = 42;
      var rnd = function () { seed = (seed * 16807) % 2147483647; return seed / 2147483647; };
      var inFinder = function (r, c) { return (r < 8 && c < 8) || (r < 8 && c >= size - 8) || (r >= size - 8 && c < 8); };
      var parts = [];
      for (var r = 0; r < size; r++) for (var c = 0; c < size; c++) { if (inFinder(r,c)) { rnd(); continue; } if (rnd() > .5) parts.push('<rect x="'+c+'" y="'+r+'" width="1" height="1" fill="#262626"/>'); }
      var finders = [[0,0],[size-7,0],[0,size-7]].map(function(f){ return '<g fill="#262626"><rect x="'+f[0]+'" y="'+f[1]+'" width="7" height="7"/><rect x="'+(f[0]+1)+'" y="'+(f[1]+1)+'" width="5" height="5" fill="#fff"/><rect x="'+(f[0]+2)+'" y="'+(f[1]+2)+'" width="3" height="3"/></g>'; }).join('');
      qrBox.innerHTML = '<svg viewBox="0 0 '+size+' '+size+'" aria-hidden="true">'+finders+parts.join('')+'</svg>';
      qrBox.dataset.qrReady = '1';
    });
  }

  function init(root) { buildBursts(root); buildStars(root); initReveal(root); initCarousel(root); initMobileSecondarySwipe(root); buildQR(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
